export enum BillPaymentStatusEnum {
  NO_DATA = 'NO_DATA',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  AWAITING_CONFIRM = 'AWAITING_CONFIRM',
  PAID = 'PAID',
  NO_OUTSTANDING_BALANCE = 'NO_OUTSTANDING_BALANCE',
  ADJUST_CONFIRMED = 'ADJUST_CONFIRMED'
}
